import { Button, Col, Row, Skeleton, Tooltip } from 'antd';
import React, { ReactElement, useState } from 'react';
import { DEFAULT_COORDINATES, GUTTOR_SPACE } from '../../../../../shared/constants/commonConstants';
import { capitalizeFirstLetter, isValidImage } from '../../../../../utils/utility';
import Map from '../../../shared/Map';
import { useDispatch, useSelector } from 'react-redux';
import { setEmailVerifyModalShow } from '../../../../../store/actions/mailBoxAction';
import { ApplicationDetailModel } from '../../../../../store/models/applicationDetailModel';
import { RootState } from '../../../../../store';
import { ReactComponent as TickIcon} from '../../../../../assets/images/svg/email-verified-tick-icon.svg';
import { HospitalState } from '../../../../../store/models/hospitalModel';
const HospitalDetail = ({ profileDetail, imgUrl }: any): ReactElement => {
  const dispatch = useDispatch();
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const { isUserEmailVerified }: any = useSelector((state: RootState): HospitalState => state.hospital);
  const [noLogo, setNoLogo] = useState(false);
  setTimeout((): any => {
    setNoLogo(true);
  }, 2000);

  return (
    <>
      {(profileDetail && Object.keys(profileDetail).length > 0) ? (
        <>
          <Row>
            <Col md={12}>
              <Col md={24}>
                <p className="label-title">Hospital Name</p>
                <div className="label-value text-wrap">{profileDetail.fullName}</div>
              </Col>
              <Col md={24}>
                <p className="label-title">Display Name</p>
                <div className="label-value text-wrap">{profileDetail.displayName}</div>
              </Col>
            </Col>
            <Col md={12} className="text-center">
              {isValidImage(imgUrl) ? (
                <img className="hosp-logo" src={`data:image/jpeg;base64,${imgUrl}`} alt="Hospital Logo" />
              ) : (<>{noLogo ? null : <Skeleton paragraph={{ rows: 2, width: '100px' }} active={true} />}</>
              )}
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            <Col>
              <p className="mb-lg fsize_sm">{capitalizeFirstLetter(profileDetail.description)}</p>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            <Col span={12}>
              <p className="label-title">Hospital Email ID</p>
              <Tooltip title={profileDetail.emailId}>
                <div className="label-value">{profileDetail.emailId}
                </div>
              </Tooltip>
            </Col>
            <Col span={12}>
              <p className="label-title">Website</p>
              <div className="label-value">{profileDetail.website}</div>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
              <Col span={18}>
              <p className="label-title">User Email ID</p>
              <Tooltip title={appdetails?._applicationDetail?.userDetail?.emailId}>
                <div className="label-value">{appdetails?._applicationDetail?.userDetail?.emailId}
                  {appdetails?.getIsUserEmailVerified() || isUserEmailVerified ? < TickIcon className="email-verified-icon"/> :
                  <Button type="link" onClick={(): any => dispatch(setEmailVerifyModalShow(true))}>
                    <p className="mx-1 text-underline text-bold">Verify</p>
                  </Button>
                  }
                </div>
              </Tooltip>
              </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            {profileDetail.landlineNumber && (
              <Col span={12}>
                <p className="label-title"> Mobile No.</p>
                <div className="label-value mb-0">{profileDetail.landlineNumber}</div>
              </Col>
            )}
            {profileDetail.tollfreeNumber && (
              <Col span={12}>
                <p className="label-title">Customer Support No.</p>
                <div className="label-value mb-0">{profileDetail.tollfreeNumber}</div>
              </Col>
            )}
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            <Col>
              <p className="label-title">Address</p>
              <div className="label-value">{capitalizeFirstLetter(profileDetail.streetAddress)}</div>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE}>
            <Col md={6}>
              <p className="label-title">State</p>
              <div className="label-value">{capitalizeFirstLetter(profileDetail.state)}</div>
            </Col>
            <Col md={6}>
              <p className="label-title">City</p>
              <div className="label-value">{capitalizeFirstLetter(profileDetail.city)}</div>
            </Col>
            <Col md={6}>
              <p className="label-title">Location</p>
              <div className="label-value">{capitalizeFirstLetter(`${profileDetail?.location}`)}</div>
            </Col>
            <Col md={6}>
              <p className="label-title">Pin Code</p>
              <div className="label-value">{profileDetail.pincode}</div>
            </Col>
            <Col md={6}>
              <p className="label-title">GST No.</p>
              <div className="label-value">{profileDetail.gstNumber}</div>
            </Col>
          </Row>
          <Row style={{ height: '300px' }} className="mb-lg">
            <Col md={24}>
              {noLogo ? (
                <Map
                  lat={+profileDetail?.latitude || DEFAULT_COORDINATES.lat}
                  lng={+profileDetail?.longitude || DEFAULT_COORDINATES.lng}
                  searchBox={false}
                  zoom={11.5}
                  containerElement={<div className="w-100 h-100" />}
                  mapElement={<div className="w-100 h-100" />}
                />
              ) :
                <Skeleton active={true} />
              }
            </Col>
          </Row>
        </>) : (
        <>
          <Skeleton active={true} paragraph={{ rows: 6 }} />
        </>
      )
      }
    </>
  );
};

export default HospitalDetail;
